import { render, staticRenderFns } from "./Controle.vue?vue&type=template&id=70b8150a&"
import script from "./Controle.vue?vue&type=script&lang=js&"
export * from "./Controle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports